export const countryCodes = [
  {
    name: "India",
    label: "+91",
    emoji: "🇮🇳",
    code: "IN",
  },
  {
    name: "United States",
    label: "+1",
    emoji: "🇺🇸",
    code: "US",
  },
  {
    name: "Russia",
    label: "+7",
    emoji: "🇷🇺",
    code: "RU",
  },
  {
    name: "Egypt",
    label: "+20",
    emoji: "🇪🇬",
    code: "EG",
  },
  {
    name: "South Africa",
    label: "+27",
    emoji: "🇿🇦",
    code: "ZA",
  },
  {
    name: "Greece",
    label: "+30",
    emoji: "🇬🇷",
    code: "GR",
  },
  {
    name: "Netherlands",
    label: "+31",
    emoji: "🇳🇱",
    code: "NL",
  },
  {
    name: "Belgium",
    label: "+32",
    emoji: "🇧🇪",
    code: "BE",
  },
  {
    name: "France",
    label: "+33",
    emoji: "🇫🇷",
    code: "FR",
  },
  {
    name: "Spain",
    label: "+34",
    emoji: "🇪🇸",
    code: "ES",
  },
  {
    name: "Hungary",
    label: "+36",
    emoji: "🇭🇺",
    code: "HU",
  },
  {
    name: "Italy",
    label: "+39",
    emoji: "🇮🇹",
    code: "IT",
  },
  {
    name: "Romania",
    label: "+40",
    emoji: "🇷🇴",
    code: "RO",
  },
  {
    name: "Switzerland",
    label: "+41",
    emoji: "🇨🇭",
    code: "CH",
  },
  {
    name: "Austria",
    label: "+43",
    emoji: "🇦🇹",
    code: "AT",
  },
  {
    name: "United Kingdom",
    label: "+44",
    emoji: "🇬🇧",
    code: "GB",
  },
  {
    name: "Denmark",
    label: "+45",
    emoji: "🇩🇰",
    code: "DK",
  },
  {
    name: "Sweden",
    label: "+46",
    emoji: "🇸🇪",
    code: "SE",
  },
  {
    name: "Norway",
    label: "+47",
    emoji: "🇳🇴",
    code: "NO",
  },
  {
    name: "Poland",
    label: "+48",
    emoji: "🇵🇱",
    code: "PL",
  },
  {
    name: "Germany",
    label: "+49",
    emoji: "🇩🇪",
    code: "DE",
  },
  {
    name: "Peru",
    label: "+51",
    emoji: "🇵🇪",
    code: "PE",
  },
  {
    name: "Mexico",
    label: "+52",
    emoji: "🇲🇽",
    code: "MX",
  },
  {
    name: "Cuba",
    label: "+53",
    emoji: "🇨🇺",
    code: "CU",
  },
  {
    name: "Argentina",
    label: "+54",
    emoji: "🇦🇷",
    code: "AR",
  },
  {
    name: "Brazil",
    label: "+55",
    emoji: "🇧🇷",
    code: "BR",
  },
  {
    name: "Chile",
    label: "+56",
    emoji: "🇨🇱",
    code: "CL",
  },
  {
    name: "Colombia",
    label: "+57",
    emoji: "🇨🇴",
    code: "CO",
  },
  {
    name: "Venezuela, Bolivarian Republic of Venezuela",
    label: "+58",
    emoji: "🇻🇪",
    code: "VE",
  },
  {
    name: "Malaysia",
    label: "+60",
    emoji: "🇲🇾",
    code: "MY",
  },
  {
    name: "Australia",
    label: "+61",
    emoji: "🇦🇺",
    code: "AU",
  },
  {
    name: "Indonesia",
    label: "+62",
    emoji: "🇮🇩",
    code: "ID",
  },
  {
    name: "Philippines",
    label: "+63",
    emoji: "🇵🇭",
    code: "PH",
  },
  {
    name: "New Zealand",
    label: "+64",
    emoji: "🇳🇿",
    code: "NZ",
  },
  {
    name: "Singapore",
    label: "+65",
    emoji: "🇸🇬",
    code: "SG",
  },
  {
    name: "Thailand",
    label: "+66",
    emoji: "🇹🇭",
    code: "TH",
  },
  {
    name: "Kazakhstan",
    label: "+77",
    emoji: "🇰🇿",
    code: "KZ",
  },
  {
    name: "Japan",
    label: "+81",
    emoji: "🇯🇵",
    code: "JP",
  },
  {
    name: "Korea, Republic of South Korea",
    label: "+82",
    emoji: "🇰🇷",
    code: "KR",
  },
  {
    name: "Vietnam",
    label: "+84",
    emoji: "🇻🇳",
    code: "VN",
  },
  {
    name: "China",
    label: "+86",
    emoji: "🇨🇳",
    code: "CN",
  },
  {
    name: "Turkey",
    label: "+90",
    emoji: "🇹🇷",
    code: "TR",
  },

  {
    name: "Pakistan",
    label: "+92",
    emoji: "🇵🇰",
    code: "PK",
  },
  {
    name: "Afghanistan",
    label: "+93",
    emoji: "🇦🇫",
    code: "AF",
  },
  {
    name: "Sri Lanka",
    label: "+94",
    emoji: "🇱🇰",
    code: "LK",
  },
  {
    name: "Myanmar",
    label: "+95",
    emoji: "🇲🇲",
    code: "MM",
  },
  {
    name: "Iran, Islamic Republic of Persian Gulf",
    label: "+98",
    emoji: "🇮🇷",
    code: "IR",
  },
  {
    name: "South Sudan",
    label: "+211",
    emoji: "🇸🇸",
    code: "SS",
  },
  {
    name: "Morocco",
    label: "+212",
    emoji: "🇲🇦",
    code: "MA",
  },
  {
    name: "Algeria",
    label: "+213",
    emoji: "🇩🇿",
    code: "DZ",
  },
  {
    name: "Tunisia",
    label: "+216",
    emoji: "🇹🇳",
    code: "TN",
  },
  {
    name: "Libyan Arab Jamahiriya",
    label: "+218",
    emoji: "🇱🇾",
    code: "LY",
  },
  {
    name: "Gambia",
    label: "+220",
    emoji: "🇬🇲",
    code: "GM",
  },
  {
    name: "Senegal",
    label: "+221",
    emoji: "🇸🇳",
    code: "SN",
  },
  {
    name: "Mauritania",
    label: "+222",
    emoji: "🇲🇷",
    code: "MR",
  },
  {
    name: "Mali",
    label: "+223",
    emoji: "🇲🇱",
    code: "ML",
  },
  {
    name: "Guinea",
    label: "+224",
    emoji: "🇬🇳",
    code: "GN",
  },
  {
    name: "Cote d'Ivoire",
    label: "+225",
    emoji: "🇨🇮",
    code: "CI",
  },
  {
    name: "Burkina Faso",
    label: "+226",
    emoji: "🇧🇫",
    code: "BF",
  },
  {
    name: "Niger",
    label: "+227",
    emoji: "🇳🇪",
    code: "NE",
  },
  {
    name: "Togo",
    label: "+228",
    emoji: "🇹🇬",
    code: "TG",
  },
  {
    name: "Benin",
    label: "+229",
    emoji: "🇧🇯",
    code: "BJ",
  },
  {
    name: "Mauritius",
    label: "+230",
    emoji: "🇲🇺",
    code: "MU",
  },
  {
    name: "Liberia",
    label: "+231",
    emoji: "🇱🇷",
    code: "LR",
  },
  {
    name: "Sierra Leone",
    label: "+232",
    emoji: "🇸🇱",
    code: "SL",
  },
  {
    name: "Ghana",
    label: "+233",
    emoji: "🇬🇭",
    code: "GH",
  },
  {
    name: "Nigeria",
    label: "+234",
    emoji: "🇳🇬",
    code: "NG",
  },
  {
    name: "Chad",
    label: "+235",
    emoji: "🇹🇩",
    code: "TD",
  },
  {
    name: "Central African Republic",
    label: "+236",
    emoji: "🇨🇫",
    code: "CF",
  },
  {
    name: "Cameroon",
    label: "+237",
    emoji: "🇨🇲",
    code: "CM",
  },
  {
    name: "Cape Verde",
    label: "+238",
    emoji: "🇨🇻",
    code: "CV",
  },
  {
    name: "Sao Tome and Principe",
    label: "+239",
    emoji: "🇸🇹",
    code: "ST",
  },
  {
    name: "Equatorial Guinea",
    label: "+240",
    emoji: "🇬🇶",
    code: "GQ",
  },
  {
    name: "Gabon",
    label: "+241",
    emoji: "🇬🇦",
    code: "GA",
  },
  {
    name: "Congo",
    label: "+242",
    emoji: "🇨🇬",
    code: "CG",
  },
  {
    name: "Congo, The Democratic Republic of the Congo",
    label: "+243",
    emoji: "🇨🇩",
    code: "CD",
  },
  {
    name: "Angola",
    label: "+244",
    emoji: "🇦🇴",
    code: "AO",
  },
  {
    name: "Guinea-Bissau",
    label: "+245",
    emoji: "🇬🇼",
    code: "GW",
  },
  {
    name: "British Indian Ocean Territory",
    label: "+246",
    emoji: "🇮🇴",
    code: "IO",
  },
  {
    name: "Seychelles",
    label: "+248",
    emoji: "🇸🇨",
    code: "SC",
  },
  {
    name: "Sudan",
    label: "+249",
    emoji: "🇸🇩",
    code: "SD",
  },
  {
    name: "Rwanda",
    label: "+250",
    emoji: "🇷🇼",
    code: "RW",
  },
  {
    name: "Ethiopia",
    label: "+251",
    emoji: "🇪🇹",
    code: "ET",
  },
  {
    name: "Somalia",
    label: "+252",
    emoji: "🇸🇴",
    code: "SO",
  },
  {
    name: "Djibouti",
    label: "+253",
    emoji: "🇩🇯",
    code: "DJ",
  },
  {
    name: "Kenya",
    label: "+254",
    emoji: "🇰🇪",
    code: "KE",
  },
  {
    name: "Tanzania, United Republic of Tanzania",
    label: "+255",
    emoji: "🇹🇿",
    code: "TZ",
  },
  {
    name: "Uganda",
    label: "+256",
    emoji: "🇺🇬",
    code: "UG",
  },
  {
    name: "Burundi",
    label: "+257",
    emoji: "🇧🇮",
    code: "BI",
  },
  {
    name: "Mozambique",
    label: "+258",
    emoji: "🇲🇿",
    code: "MZ",
  },
  {
    name: "Zambia",
    label: "+260",
    emoji: "🇿🇲",
    code: "ZM",
  },
  {
    name: "Madagascar",
    label: "+261",
    emoji: "🇲🇬",
    code: "MG",
  },
  {
    name: "Zimbabwe",
    label: "+263",
    emoji: "🇿🇼",
    code: "ZW",
  },
  {
    name: "Namibia",
    emoji: "🇳🇦",
    label: "+264",
    code: "NA",
  },
  {
    name: "Malawi",
    label: "+265",
    emoji: "🇲🇼",
    code: "MW",
  },
  {
    name: "Lesotho",
    label: "+266",
    emoji: "🇱🇸",
    code: "LS",
  },
  {
    name: "Botswana",
    label: "+267",
    emoji: "🇧🇼",
    code: "BW",
  },
  {
    name: "Swaziland",
    label: "+268",
    emoji: "🇸🇿",
    code: "SZ",
  },
  {
    name: "Comoros",
    label: "+269",
    emoji: "🇰🇲",
    code: "KM",
  },
  {
    name: "Saint Helena, Ascension and Tristan Da Cunha",
    label: "+290",
    emoji: "🇸🇭",
    code: "SH",
  },
  {
    name: "Eritrea",
    label: "+291",
    emoji: "🇪🇷",
    code: "ER",
  },
  {
    name: "Aruba",
    label: "+297",
    emoji: "🇦🇼",
    code: "AW",
  },
  {
    name: "Faroe Islands",
    label: "+298",
    emoji: "🇫🇴",
    code: "FO",
  },
  {
    name: "Greenland",
    label: "+299",
    emoji: "🇬🇱",
    code: "GL",
  },
  {
    name: "Cayman Islands",
    label: "+345",
    emoji: "🇰🇾",
    code: "KY",
  },
  {
    name: "Gibraltar",
    label: "+350",
    emoji: "🇬🇮",
    code: "GI",
  },
  {
    name: "Portugal",
    label: "+351",
    emoji: "🇵🇹",
    code: "PT",
  },
  {
    name: "Luxembourg",
    label: "+352",
    emoji: "🇱🇺",
    code: "LU",
  },
  {
    name: "Ireland",
    label: "+353",
    emoji: "🇮🇪",
    code: "IE",
  },
  {
    name: "Iceland",
    label: "+354",
    emoji: "🇮🇸",
    code: "IS",
  },
  {
    name: "Albania",
    label: "+355",
    emoji: "🇦🇱",
    code: "AL",
  },
  {
    name: "Malta",
    label: "+356",
    emoji: "🇲🇹",
    code: "MT",
  },
  {
    name: "Cyprus",
    label: "+357",
    emoji: "🇨🇾",
    code: "CY",
  },
  {
    name: "Finland",
    label: "+358",
    emoji: "🇫🇮",
    code: "FI",
  },
  {
    name: "Bulgaria",
    label: "+359",
    emoji: "🇧🇬",
    code: "BG",
  },
  {
    name: "Lithuania",
    label: "+370",
    emoji: "🇱🇹",
    code: "LT",
  },
  {
    name: "Latvia",
    label: "+371",
    emoji: "🇱🇻",
    code: "LV",
  },
  {
    name: "Estonia",
    label: "+372",
    emoji: "🇪🇪",
    code: "EE",
  },
  {
    name: "Moldova",
    label: "+373",
    emoji: "🇲🇩",
    code: "MD",
  },
  {
    name: "Armenia",
    label: "+374",
    emoji: "🇦🇲",
    code: "AM",
  },
  {
    name: "Belarus",
    label: "+375",
    emoji: "🇧🇾",
    code: "BY",
  },
  {
    name: "Andorra",
    label: "+376",
    emoji: "🇦🇩",
    code: "AD",
  },
  {
    name: "Monaco",
    label: "+377",
    emoji: "🇲🇨",
    code: "MC",
  },
  {
    name: "San Marino",
    label: "+378",
    emoji: "🇸🇲",
    code: "SM",
  },
  {
    name: "Holy See (Vatican City State)",
    label: "+379",
    emoji: "🇻🇦",
    code: "VA",
  },
  {
    name: "Ukraine",
    label: "+380",
    emoji: "🇺🇦",
    code: "UA",
  },
  {
    name: "Serbia",
    label: "+381",
    emoji: "🇷🇸",
    code: "RS",
  },
  {
    name: "Montenegro",
    label: "+382",
    emoji: "🇲🇪",
    code: "ME",
  },
  {
    name: "Croatia",
    label: "+385",
    emoji: "🇭🇷",
    code: "HR",
  },
  {
    name: "Slovenia",
    label: "+386",
    emoji: "🇸🇮",
    code: "SI",
  },
  {
    name: "Bosnia and Herzegovina",
    label: "+387",
    emoji: "🇧🇦",
    code: "BA",
  },
  {
    name: "Macedonia",
    label: "+389",
    emoji: "🇲🇰",
    code: "MK",
  },
  {
    name: "Czech Republic",
    label: "+420",
    emoji: "🇨🇿",
    code: "CZ",
  },
  {
    name: "Slovakia",
    label: "+421",
    emoji: "🇸🇰",
    code: "SK",
  },
  {
    name: "Liechtenstein",
    label: "+423",
    emoji: "🇱🇮",
    code: "LI",
  },
  {
    name: "Falkland Islands (Malvinas)",
    label: "+500",
    emoji: "🇫🇰",
    code: "FK",
  },
  {
    name: "Belize",
    label: "+501",
    emoji: "🇧🇿",
    code: "BZ",
  },
  {
    name: "Guatemala",
    label: "+502",
    emoji: "🇬🇹",
    code: "GT",
  },
  {
    name: "El Salvador",
    label: "+503",
    emoji: "🇸🇻",
    code: "SV",
  },
  {
    name: "Honduras",
    label: "+504",
    emoji: "🇭🇳",
    code: "HN",
  },
  {
    name: "Nicaragua",
    label: "+505",
    emoji: "🇳🇮",
    code: "NI",
  },
  {
    name: "Costa Rica",
    label: "+506",
    emoji: "🇨🇷",
    code: "CR",
  },
  {
    name: "Panama",
    label: "+507",
    emoji: "🇵🇦",
    code: "PA",
  },
  {
    name: "Saint Pierre and Miquelon",
    label: "+508",
    emoji: "🇵🇲",
    code: "PM",
  },
  {
    name: "Haiti",
    label: "+509",
    emoji: "🇭🇹",
    code: "HT",
  },
  {
    name: "Bolivia, Plurinational State of",
    label: "+591",
    emoji: "🇧🇴",
    code: "BO",
  },
  {
    name: "Ecuador",
    label: "+593",
    emoji: "🇪🇨",
    code: "EC",
  },
  {
    name: "French Guiana",
    label: "+594",
    emoji: "🇬🇫",
    code: "GF",
  },
  {
    name: "Paraguay",
    label: "+595",
    emoji: "🇵🇾",
    code: "PY",
  },
  {
    name: "Martinique",
    label: "+596",
    emoji: "🇲🇶",
    code: "MQ",
  },
  {
    name: "Suriname",
    label: "+597",
    emoji: "🇸🇷",
    code: "SR",
  },
  {
    name: "Uruguay",
    label: "+598",
    emoji: "🇺🇾",
    code: "UY",
  },
  {
    name: "Netherlands Antilles",
    label: "+599",
    emoji: "🇧🇶",
    code: "AN",
  },
  {
    name: "Timor-Leste",
    label: "+670",
    emoji: "🇹🇱",
    code: "TL",
  },
  {
    name: "Antarctica",
    label: "+672",
    emoji: "🇦🇶",
    code: "AQ",
  },
  {
    name: "Brunei Darussalam",
    label: "+673",
    emoji: "🇧🇳",
    code: "BN",
  },
  {
    name: "Nauru",
    label: "+674",
    emoji: "🇳🇷",
    code: "NR",
  },
  {
    name: "Papua New Guinea",
    label: "+675",
    emoji: "🇵🇬",
    code: "PG",
  },
  {
    name: "Tonga",
    label: "+676",
    emoji: "🇹🇴",
    code: "TO",
  },
  {
    name: "Solomon Islands",
    label: "+677",
    emoji: "🇸🇧",
    code: "SB",
  },
  {
    name: "Vanuatu",
    label: "+678",
    emoji: "🇻🇺",
    code: "VU",
  },
  {
    name: "Fiji",
    label: "+679",
    emoji: "🇫🇯",
    code: "FJ",
  },
  {
    name: "Palau",
    label: "+680",
    emoji: "🇵🇼",
    code: "PW",
  },
  {
    name: "Wallis and Futuna",
    label: "+681",
    emoji: "🇼🇫",
    code: "WF",
  },
  {
    name: "Cook Islands",
    label: "+682",
    emoji: "🇨🇰",
    code: "CK",
  },
  {
    name: "Niue",
    label: "+683",
    emoji: "🇳🇺",
    code: "NU",
  },
  {
    name: "Samoa",
    label: "+685",
    emoji: "🇼🇸",
    code: "WS",
  },
  {
    name: "Kiribati",
    label: "+686",
    emoji: "🇰🇮",
    code: "KI",
  },
  {
    name: "New Caledonia",
    label: "+687",
    emoji: "🇳🇨",
    code: "NC",
  },
  {
    name: "Tuvalu",
    label: "+688",
    emoji: "🇹🇻",
    code: "TV",
  },
  {
    name: "French Polynesia",
    label: "+689",
    emoji: "🇵🇫",
    code: "PF",
  },
  {
    name: "Tokelau",
    label: "+690",
    emoji: "🇹🇰",
    code: "TK",
  },
  {
    name: "Micronesia, Federated States of Micronesia",
    label: "+691",
    emoji: "🇫🇲",
    code: "FM",
  },
  {
    name: "Marshall Islands",
    label: "+692",
    emoji: "🇲🇭",
    code: "MH",
  },
  {
    name: "Korea, Democratic People's Republic of Korea",
    label: "+850",
    emoji: "🇰🇵",
    code: "KP",
  },
  {
    name: "Hong Kong",
    label: "+852",
    emoji: "🇭🇰",
    code: "HK",
  },
  {
    name: "Macao",
    label: "+853",
    emoji: "🇲🇴",
    code: "MO",
  },
  {
    name: "Cambodia",
    label: "+855",
    emoji: "🇰🇭",
    code: "KH",
  },
  {
    name: "Laos",
    label: "+856",
    emoji: "🇱🇦",
    code: "LA",
  },
  {
    name: "Pitcairn",
    label: "+872",
    emoji: "🇵🇳",
    code: "PN",
  },
  {
    name: "Bangladesh",
    label: "+880",
    emoji: "🇧🇩",
    code: "BD",
  },
  {
    name: "Taiwan",
    label: "+886",
    emoji: "🇹🇼",
    code: "TW",
  },
  {
    name: "Maldives",
    label: "+960",
    emoji: "🇲🇻",
    code: "MV",
  },
  {
    name: "Lebanon",
    label: "+961",
    emoji: "🇱🇧",
    code: "LB",
  },
  {
    name: "Jordan",
    label: "+962",
    emoji: "🇯🇴",
    code: "JO",
  },
  {
    name: "Syrian Arab Republic",
    label: "+963",
    emoji: "🇸🇾",
    code: "SY",
  },
  {
    name: "Iraq",
    label: "+964",
    emoji: "🇮🇷",
    code: "IQ",
  },
  {
    name: "Kuwait",
    label: "+965",
    emoji: "🇰🇼",
    code: "KW",
  },
  {
    name: "Saudi Arabia",
    label: "+966",
    emoji: "🇸🇦",
    code: "SA",
  },
  {
    name: "Yemen",
    label: "+967",
    emoji: "🇾🇪",
    code: "YE",
  },
  {
    name: "Oman",
    label: "+968",
    emoji: "🇴🇲",
    code: "OM",
  },
  {
    name: "Palestinian Territory, Occupied",
    label: "+970",
    emoji: "🇵🇸",
    code: "PS",
  },
  {
    name: "United Arab Emirates",
    label: "+971",
    emoji: "🇦🇪",
    code: "AE",
  },
  {
    name: "Israel",
    label: "+972",
    emoji: "🇮🇱",
    code: "IL",
  },
  {
    name: "Bahrain",
    label: "+973",
    emoji: "🇧🇭",
    code: "BH",
  },
  {
    name: "Qatar",
    label: "+974",
    emoji: "🇶🇦",
    code: "QA",
  },
  {
    name: "Bhutan",
    label: "+975",
    emoji: "🇧🇹",
    code: "BT",
  },
  {
    name: "Mongolia",
    label: "+976",
    emoji: "🇲🇳",
    code: "MN",
  },
  {
    name: "Nepal",
    label: "+977",
    emoji: "🇳🇵",
    code: "NP",
  },
  {
    name: "Tajikistan",
    label: "+992",
    emoji: "🇹🇯",
    code: "TJ",
  },
  {
    name: "Turkmenistan",
    label: "+993",
    emoji: "🇹🇲",
    code: "TM",
  },
  {
    name: "Azerbaijan",
    label: "+994",
    emoji: "🇦🇿",
    code: "AZ",
  },
  {
    name: "Georgia",
    label: "+995",
    emoji: "🇬🇪",
    code: "GE",
  },
  {
    name: "Kyrgyzstan",
    label: "+996",
    emoji: "🇰🇬",
    code: "KG",
  },
  {
    name: "Uzbekistan",
    label: "+998",
    emoji: "🇺🇿",
    code: "UZ",
  },
  {
    name: "Bahamas",
    label: "+1242",
    emoji: "🇧🇸",
    code: "BS",
  },
  {
    name: "Barbados",
    label: "+1246",
    emoji: "🇧🇧",
    code: "BB",
  },
  {
    name: "Anguilla",
    label: "+1264",
    emoji: "🇦🇮",
    code: "AI",
  },
  {
    name: "Antigua and Barbuda",
    label: "+1268",
    emoji: "🇦🇬",
    code: "AG",
  },
  {
    name: "Virgin Islands, British",
    label: "+1284",
    emoji: "🇻🇬",
    code: "VG",
  },
  {
    name: "Virgin Islands, U.S.",
    label: "+1340",
    emoji: "🇻🇮",
    code: "VI",
  },
  {
    name: "Bermuda",
    label: "+1441",
    emoji: "🇧🇲",
    code: "BM",
  },
  {
    name: "Grenada",
    label: "+1473",
    emoji: "🇬🇩",
    code: "GD",
  },
  {
    name: "Turks and Caicos Islands",
    label: "+1649",
    emoji: "🇹🇨",
    code: "TC",
  },
  {
    name: "Montserrat",
    label: "+1664",
    emoji: "🇲🇸",
    code: "MS",
  },
  {
    name: "Northern Mariana Islands",
    label: "+1670",
    emoji: "🇲🇵",
    code: "MP",
  },
  {
    name: "Guam",
    label: "+1671",
    emoji: "🇬🇺",
    code: "GU",
  },
  {
    name: "AmericanSamoa",
    label: "+1684",
    emoji: "🇦🇸",
    code: "AS",
  },
  {
    name: "Saint Lucia",
    label: "+1758",
    emoji: "🇱🇨",
    code: "LC",
  },
  {
    name: "Dominica",
    label: "+1767",
    emoji: "🇩🇲",
    code: "DM",
  },
  {
    name: "Saint Vincent and the Grenadines",
    label: "+1784",
    emoji: "🇻🇨",
    code: "VC",
  },
  {
    name: "Dominican Republic",
    label: "+1849",
    emoji: "🇩🇴",
    code: "DO",
  },
  {
    name: "Trinidad and Tobago",
    label: "+1868",
    emoji: "🇹🇹",
    code: "TT",
  },
  {
    name: "Saint Kitts and Nevis",
    label: "+1869",
    emoji: "🇰🇳",
    code: "KN",
  },
  {
    name: "Jamaica",
    label: "+1876",
    emoji: "🇯🇲",
    code: "JM",
  },
  {
    name: "Puerto Rico",
    label: "+1939",
    emoji: "🇵🇷",
    code: "PR",
  },
];
